import { render, staticRenderFns } from "./Objects.vue?vue&type=template&id=c6c7dda0&lang=pug&"
import script from "./Objects.vue?vue&type=script&lang=js&"
export * from "./Objects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6c7dda0')) {
      api.createRecord('c6c7dda0', component.options)
    } else {
      api.reload('c6c7dda0', component.options)
    }
    module.hot.accept("./Objects.vue?vue&type=template&id=c6c7dda0&lang=pug&", function () {
      api.rerender('c6c7dda0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/docs/Objects.vue"
export default component.exports